import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './Modules/app-routing.module';
import { AppComponent } from './app.component';


import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { SeasonsListComponent } from './Components/seasonsList/seasons.component';
import { SeasonComponent } from './Components/season/season.component';
import { CourseComponent } from './Components/course/course.component';
import { RunComponent } from './Components/run/run.component';
import { NewCourseComponent } from './Components/course/new-course/new-course.component';
import { NewSeasonComponent } from './Components/season/new-season/new-season.component';
import { NewRunComponent } from './Components/run/new-run/new-run.component';
import { NewNinjaComponent } from './Components/ninja/new-ninja/new-ninja.component';
import { CompareComponent } from './Components/compare/compare.component';
import { MaterialModule } from './Modules/material.module';
import { TimestampToDatePipe } from './Pipes/timestampToDate/timestamp-to-date.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewObstacleComponent } from './Components/obstacle/new-obstacle/new-obstacle.component';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatSpinnerContainerComponent } from './Components/mat-spinner-container/mat-spinner-container.component';
import { SadfaceMessageComponent } from './sadface-message/sadface-message.component';
import { TimeFormatterPipe } from './Pipes/timeFormatter/time-formatter.pipe';


@NgModule({
  declarations: [
    AppComponent,
    SeasonsListComponent,
    SeasonComponent,
    CourseComponent,
    RunComponent,
    NewCourseComponent,
    NewSeasonComponent,
    NewRunComponent,
    NewNinjaComponent,
    CompareComponent,
    TimestampToDatePipe,
    NewObstacleComponent,
    MatSpinnerContainerComponent,
    SadfaceMessageComponent,
    TimeFormatterPipe,
  ],
  imports: [
    MaterialModule,
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    NewNinjaComponent,
    NewCourseComponent,
    NewRunComponent,
    NewSeasonComponent,
    NewObstacleComponent,
    MatSpinnerContainerComponent,
    SadfaceMessageComponent
  ]
})
export class AppModule { }
